import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ProjectsContext } from '#providers/projects/Projects.context.ts';
import type { TProjectsContextValue } from '#providers/projects/Projects.types.ts';

export const useProjects = (): TProjectsContextValue =>
  useRequiredContext(
    ProjectsContext,
    'useProjects is only available inside a ProjectsProvider',
  );
